<template>
  <div class="view">
    <!-- <div class="">
      {{stage}}
    </div> -->
    <header>
      <h1>All is Not Forgiven<br>John Kenneth Paranada</h1>
    </header>

    <VueShowdown
    :markdown="md"
    flavor="github"
    tag="article"
    class="essay"
    />
  </div>
</template>

<script>
import mdFile from '@/markdown/all-is-not-forgiven.md'
// @ is an alias to /src
export default {
  name: 'Essay',
  data () {
    return {
      text: ''
    }
  },
  computed: {
    stage () {
      return this.$store.state.stage
    },
    md () {
      return mdFile
    }
  }
}
</script>

<style lang="scss" scoped>
.view {
  pointer-events: auto;
}
h1 {
  // color: blue;
}

</style>
